import Pagination from './pagination/zh_TW';
import DatePicker from './datePicker/zh_TW';
import TimePicker from './timePicker/zh_TW';
import Calendar from './calendar/zh_TW';

export default {
  locale: 'zh-tw',
  Pagination,
  DatePicker,
  TimePicker,
  Calendar,
  global: {
    placeholder: '請選擇',
  },
  Form: {
    switchControl: '切換控制項',
  },
  Table: {
    filterTitle: '篩選器',
    filterConfirm: '確定',
    filterReset: '重置',
    selected: '已選擇',
    selectAll: '全部選取',
    selectInvert: '反向選取',
    sortTitle: '排序',
    expand: '展開行',
    collapse: '關閉行',
    term: '項',
    allData: '共',
    selectedAll: '選中全部'
  },
  Modal: {
    okText: '確定',
    cancelText: '取消',
    clearText: '清空',
    justOkText: '知道了',
  },
  Popconfirm: {
    okText: '確定',
    cancelText: '取消',
    removeFile: '刪除檔案',
  },
  Transfer: {
    searchPlaceholder: '搜尋資料',
    itemUnit: '項目',
    itemsUnit: '項目',
  },
  Download: {
    error: '下載失敗',
    success: '下載成功',
    messageLink: '未識別到檔案下載連結',
    messageRequest: '未識別到可用下載請求地址',
  },
  Upload: {
    error: '上傳失敗',
    success: '上傳成功',
    uploading: '正在上傳...',
    removeFile: '刪除檔案',
    uploadError: '上傳失敗',
    previewFile: '檔案預覽',
    downloadFile: '下载文件',
    downloadTemplate: '下載標準範本',
  },
  Empty: {
    description: '無此資料',
  },
  PageHeader: {
    back: '返回',
    loginOut: '登入退出',
  },
  Breadcrumb: {
    more: '更多',
  },
  ElectronicDocument: {
    upload: '上傳電子檔',
  },
  SpeedDials: {
    title: '快捷應用',
  },
};
